import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@shared/services';
import { FormBuilder } from '@angular/forms';

import { Voucher, VouchersResolve } from '@shared/models';
import { VoucherService } from './voucher.service';
import { setFormErrors, TypedRoute } from '@shared/utils';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrl: './voucher.component.scss',
})
export class VoucherComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  vouchers: Voucher[] = [];
  plannedInvoiceMonth = this.getNextMonth();

  voucherForm = this._formBuilder.group({
    code: [''],
  });

  readonly TargetInvoiceType: Record<Voucher['target_invoice_type'], { key: string; icon: string }[]> = {
    all: [{ key: 'contract', icon: 'fa-file-contract' }, { key: 'pay_per_use', icon: 'fa-clock' }],
    contract: [{ key: 'contract', icon: 'fa-file-contract' }],
    pay_per_use: [{ key: 'pay_per_use', icon: 'fa-clock' }],
  };

  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<VouchersResolve>,
    private _formBuilder: FormBuilder,
    private toastService: ToastService,
    private voucherService: VoucherService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.voucherService.setVouchers(data.vouchers);
    });


    this.voucherService.vouchers.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (vouchers) => {
        this.vouchers = vouchers;
      },
      error: () => {},
    });

  }

  private getNextMonth(): Date {
    const nextMonth = new Date();
    nextMonth.setDate(1);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    return nextMonth;
  }

  handleSubmit() {
    const code = this.voucherForm.value.code?.trim();

    if (code) {
      this.voucherService
        .redeemVoucher(code)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (response) => {
            this.vouchers = [response, ...this.vouchers ];
            this.toastService.showSuccess(this.translateService.instant('Voucher.RedeemSuccess'));
            this.voucherForm.reset();
          },
          error: (error) => {
            setFormErrors(error.error.detail, this.voucherForm);
            this.toastService.showError(this.translateService.instant('Voucher.RedeemError'));
          },
        });
    }
  }
}
